import TSettingUserGroupsCreate from './index.vue';

TSettingUserGroupsCreate.install = app => {
  app.component(TSettingUserGroupsCreate.name, TSettingUserGroupsCreate);
};

export default TSettingUserGroupsCreate;
